export const blockIconsNavigationMapsHomeWork = (
	<span className='material-symbols-outlined'>maps_home_work</span>
);
